import { PostResponse } from '@/blog/domain/BlogResponse';
import { dateHelpers } from '@hfc/ui-core';
const { fromUnixToFormatted } = dateHelpers();
export class Post {

  public date: number;
  public image: string;
  public title: string;
  public content: string;
  public slug: string;
  public author: PostResponse['author'];

  public constructor (postResponse: PostResponse) {
    this.date = postResponse.date;
    this.image = postResponse.thumbnail;
    this.slug = postResponse.slug;
    this.content = postResponse.content;
    this.title = postResponse.title;
    this.author = postResponse.author;
  }

  public get formattedDate (): string {
    return fromUnixToFormatted(this.date, 'MMM. Do, YYYY');
  }

  public get imageUrl (): string {
    return this.image;
  }

  public get excerpt (): string {
    return this.content.slice(0, 100);
  }

}
